import React, { useState, useMemo } from 'react';

const InGameAnalyticsWrap = (props: any) => {
  const { children, cardList, defaultTab=true, metricsList, ...restProps } = props || {};
  const [activeTab, setActiveTab] = useState(defaultTab || '');

  // 处理 cardList 的逻辑
  const selectedCardConfig = useMemo(() => {
    if (Array.isArray(cardList)) {
      return cardList.find((item: any) => item.id === activeTab)?.config || [];
    } if (cardList && typeof cardList === 'object') {
      // 没配置tab时可传入对象数据
      return cardList.config || [];
    }
    return [];
  }, [cardList, activeTab]);

  return (
    <>
      {React.Children.map(children, (child: any) =>
        React.cloneElement(child, {
          customConfig: selectedCardConfig,
          setActiveTab,
          activeTab,
          ...restProps,
        })
      )}
    </>
  );
};

export default InGameAnalyticsWrap;
